import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import countries from 'i18n-iso-countries';
import englishLocale from 'i18n-iso-countries/langs/en.json';
import { COUNTRY_LIST_LANGUAGE, COUNTRY_LIST_TYPE } from '../../constants';

countries.registerLocale(englishLocale);

interface CountryOption {
    code: string;
    name: string;
}

const CountrySelect = ({ value, onChange }: { value: string, onChange: (value: string) => void }) => {
    const countryList = countries.getNames(COUNTRY_LIST_LANGUAGE, { select: COUNTRY_LIST_TYPE });
    const countryOptions = Object.entries(countryList).map(([code, name]) => ({ code, name }));

    const handleAutocompleteChange = (_event: React.ChangeEvent<{}>, newValue: CountryOption | null) => {
        onChange(newValue ? newValue.code : '');
    };

    return (
        <Autocomplete
            options={countryOptions}
            getOptionLabel={(option) => option.name}
            value={countryOptions.find(country => country.code === value) || null}
            onChange={handleAutocompleteChange}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            renderInput={(params) => (
                <TextField {...params} label="Country" fullWidth />
            )}
        />
    );
};

export default CountrySelect;
